import { render, staticRenderFns } from "./jpushMsg.vue?vue&type=template&id=aa9e7204"
import script from "./jpushMsg.vue?vue&type=script&lang=js"
export * from "./jpushMsg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports